import styled from "styled-components";

const Root = styled("div")`
	height: 525px;
`;
export default Root;
